const services = {
  UNIT_ACTIONS: 'settings-unit-actions',
};

export default services;
